<ui-section
	title="Details"
	[collapsable]="true"
	[testHook]="testHooks.DetailsSection"
>
	<div section-content>
		<div class="flex">
			<app-input
				label="Name"
				[ngModel]="_client.name"
				(debounce)="onNameChanged($event)"
				[required]="true"
				[submitted]="true"
				[testHook]="testHooks.Name"
			></app-input>
			<app-select
				label="Type"
				[ngModel]="_client.type"
				(ngModelChange)="onTypeChanged($event)"
				class="mx-3"
				[testHook]="testHooks.TypeSelect"
			>
				<option [value]="clientTypes.CORPORATION" [testHook]="testHooks.Option">
					Client Corporation
				</option>
				<option [value]="clientTypes.BUILDER" [testHook]="testHooks.Option1">
					Builder
				</option>
			</app-select>
			<app-radio-group
				class="w-1/3"
				name="canadianCompany"
				label="Canadian Company?"
				[items]="yesNoOptions"
				(ngModelChange)="onCanadianCompanyChange($event)"
				[ngModel]="_client.canadianCompany"
				[testHook]="testHooks.CanadianCompanyRadioGroup"
			></app-radio-group>
		</div>
		<div class="flex row">
			<app-input
				label="Jurisdiction"
				[ngModel]="_client.jurisdiction"
				(debounce)="onJurisdictionChanged($event)"
				class="flex flex-1"
				[testHook]="testHooks.Jurisdiction"
			></app-input>
			<app-input
				label="Corporation number"
				[ngModel]="_client.corporationNumber"
				(debounce)="onCorporationNumberChanged($event)"
				class="mx-3"
				[testHook]="testHooks.CorporationNumber"
			></app-input>
			<app-input
				label="Date of incorporation"
				[ngModel]="_client.dateOfIncorporation"
				(debounce)="onDateOfIncorporationChanged($event)"
				[testHook]="testHooks.DateOfIncorporation"
			></app-input>
		</div>
		<div class="flex row">
			<div class="flex flex-1">
				<app-region-select
					label="Province of incorporation"
					[country]="'Canada'"
					[province]="_client.provinceOfIncorporation"
					(provinceChange)="onProvinceOfIncorporationChanged($event)"
					[testHook]="testHooks.ProvinceOfIncorporationRegionSelect"
				></app-region-select>
			</div>
			<app-input
				label="Business Activity"
				[ngModel]="_client.businessActivity"
				(debounce)="onBusinessActivityChanged($event)"
				class="mx-3"
				[testHook]="testHooks.BusinessActivity"
			></app-input>
			<app-input
				label="Record Source"
				[ngModel]="_client?.recordSource"
				(debounce)="onRecordSourceChanged($event)"
				[testHook]="testHooks.RecordSource"
			></app-input>
		</div>
		<div class="flex row">
			<app-add-client-button
				[type]="associateTypes.SIGNING_OFFICER"
				[clientId]="_client.id"
			></app-add-client-button>
		</div>
		<app-client-tab-profile [client]="_client"></app-client-tab-profile>
	</div>
</ui-section>

<ui-section
	title="Contact Details"
	[collapsable]="true"
	class="mt-5"
	[testHook]="testHooks.ContactDetailsSection"
>
	<div section-content>
		<div class="flex gap-3">
			<app-input
				label="Business phone"
				name="phone"
				(debounce)="onPhoneChanged($event)"
				[ngModel]="_client.phone"
				[testHook]="testHooks.BusinessPhone"
			></app-input>
			<app-input
				label="Business fax"
				name="fax"
				(debounce)="onFaxChanged($event)"
				[ngModel]="_client.fax"
				[testHook]="testHooks.BusinessFax"
			></app-input>
		</div>
		<div class="flex flex-col gap-3 mt-3">
			<app-input
				label="Business Email"
				(debounce)="onEmailChanged($event)"
				[ngModel]="_client.email"
				[testHook]="testHooks.BusinessEmail"
			></app-input>
			<app-address
				name="Address"
				[address]="_client?.serviceAddress"
				(onAddressUpdate)="setServiceAddress($event)"
				[enableCountrySelect]="true"
				[displayCountryTop]="false"
			>
			</app-address>
		</div>
	</div>
</ui-section>

<ui-section
	title="Salutations"
	class="mt-5"
	[collapsable]="true"
	[testHook]="testHooks.SalutationsSection"
>
	<div section-content class="flex flex-1">
		<app-text-area
			label="Re: line"
			[ngModel]="_client.reLine"
			(debounce)="onReLineChanged($event)"
			[testHook]="testHooks.TextArea"
		></app-text-area>
		<div class="ml-3 flex flex-1 flex-col">
			<app-input-wrapper
				label="Primary salutation"
				[testHook]="testHooks.PrimarySalutationInputWrapper"
			>
				<div class="flex">
					<app-select
						[ngModel]="_client.primarySalutationOption"
						(ngModelChange)="onPrimarySalutationTypeChanged($event)"
						[testHook]="testHooks.PrimarySalutationTypeSelect"
					>
						<option
							[value]="salutationTypes.FORMAL"
							[testHook]="testHooks.Option2"
						>
							Formal
						</option>
						<option
							[value]="salutationTypes.INFORMAL"
							[testHook]="testHooks.Option3"
						>
							Informal
						</option>
						<option
							[value]="salutationTypes.CUSTOM"
							[testHook]="testHooks.Option4"
						>
							Custom
						</option>
					</app-select>
					<app-input
						class="ml-5"
						[ngModel]="primarySalutation"
						(debounce)="onPrimarySalutationChanged($event)"
						[testHook]="testHooks.PrimarySalutation"
					></app-input>
				</div>
			</app-input-wrapper>
			<app-input-wrapper
				label="Envelope salutation"
				class="row"
				[testHook]="testHooks.EnvelopeSalutationInputWrapper"
			>
				<div class="flex">
					<app-select
						[ngModel]="_client.envelopeSalutationOption"
						(ngModelChange)="onEnvelopeSalutationTypeChanged($event)"
						[testHook]="testHooks.EnvelopeSalutationTypeSelect"
					>
						<option
							[value]="salutationTypes.FORMAL"
							[testHook]="testHooks.Option5"
						>
							Formal
						</option>
						<option
							[value]="salutationTypes.INFORMAL"
							[testHook]="testHooks.Option6"
						>
							Informal
						</option>
						<option
							[value]="salutationTypes.CUSTOM"
							[testHook]="testHooks.Option7"
						>
							Custom
						</option>
					</app-select>
					<app-input
						class="ml-5"
						[ngModel]="envelopeSalutation"
						(debounce)="onEnvelopeSalutationChanged($event)"
						[testHook]="testHooks.EnvelopeSalutation"
					></app-input>
				</div>
			</app-input-wrapper>
			<app-input
				class="row"
				label="Envelope salutation (continued)"
				[ngModel]="_client.envelopeSalutationContd"
				(debounce)="onEnvelopeSalutationContChanged($event)"
				[testHook]="testHooks.Input"
			></app-input>
		</div>
	</div>
</ui-section>
